(function () {
  'use strict';

  function setExpandedHeight(answer) {
    answer.style.height = answer.scrollHeight + 'px';
  }

  function openItem(item) {
    var button = item.querySelector('.faq-question');
    var answer = item.querySelector('.faq-answer');

    if (!button || !answer) {
      return;
    }

    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');
    setExpandedHeight(answer);
  }

  function closeItem(item) {
    var button = item.querySelector('.faq-question');
    var answer = item.querySelector('.faq-answer');

    if (!button || !answer) {
      return;
    }

    if (item.classList.contains('is-open')) {
      answer.style.height = answer.scrollHeight + 'px';
      answer.offsetHeight;
    }

    item.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    answer.style.height = '0px';
  }

  function initFaqAccordion(section) {
    if (!section || section.dataset.faqInitialized === 'true') {
      return;
    }

    var items = section.querySelectorAll('.faq-item');
    var closeOthers = section.dataset.closeOthers !== 'false';
    var firstOpen = section.dataset.firstOpen === 'true';

    items.forEach(function (item) {
      var button = item.querySelector('.faq-question');
      var answer = item.querySelector('.faq-answer');

      if (!button || !answer) {
        return;
      }

      answer.style.height = '0px';

      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (closeOthers) {
          items.forEach(function (otherItem) {
            if (otherItem !== item) {
              closeItem(otherItem);
            }
          });
        }

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });

      button.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && item.classList.contains('is-open')) {
          closeItem(item);
          button.focus();
        }
      });

      answer.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'height') {
          return;
        }

        if (item.classList.contains('is-open')) {
          answer.style.height = 'auto';
        }
      });
    });

    if (firstOpen && items.length > 0) {
      openItem(items[0]);
    }

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) {
          var answer = item.querySelector('.faq-answer');
          if (answer) {
            answer.style.height = 'auto';
            setExpandedHeight(answer);
          }
        }
      });
    });

    section.dataset.faqInitialized = 'true';
  }

  function initAllFaqSections(scope) {
    var root = scope || document;
    root.querySelectorAll('.faq-section').forEach(initFaqAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllFaqSections(document);
    });
  } else {
    initAllFaqSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllFaqSections(event.target);
  });
})();
